import { render, staticRenderFns } from "./VeJwMyGzzjList.vue?vue&type=template&id=11c9588a&scoped=true"
import script from "./VeJwMyGzzjList.vue?vue&type=script&lang=js"
export * from "./VeJwMyGzzjList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c9588a",
  null
  
)

export default component.exports